export default "__VITE_ASSET__92a8f8b5__"